module.exports = __webpack_public_path__ + "src/assets/img/hand-ico.08d4accc.png";